/**
 * registerUiItem
 * @param {Object} : uiItem as object of dataFn and name to register
 * {
 *    name: String - <component namespace>
 *    dataFn: Function - AlpineJS x-data function
 * }
 */
const registerUiItem = ({ name, dataFn }) => {
    window.sui = window.sui || {};
    try {
        if (!window.sui[name]) {
            window.sui[name] = dataFn;
        }
    } catch (e) {
        console.error(e); // eslint-disable-line
    }
};

export const directive = (name, fn) => registerUiItem({ name, dataFn: fn });
